
        var normalize = require("../../../node_modules/san-loader/lib/runtime/normalize.js");
        require('/Users/duanhong/Source/Lean/LeanPM/webapps/shared/src/components/CopyInfo/CopyInfo.san?lang=less&san=&type=style&index=0');
var injectStyles = [];

        var template = require('./CopyInfo.html');
        
        var script = require('./CopyInfo.ts').default;
        module.exports = require('./CopyInfo.ts');
    
        module.exports.default = normalize(script, template, injectStyles);
        /* san-hmr component */
    